module.exports = __webpack_public_path__ + "img/orgIcon.de56247.png";